// extracted by mini-css-extract-plugin
module.exports = {"container":"_a41cf4d","wrapper":"_46499619","visuallySimilarHeader":"_a0efa475","viewMoreLink":"_c2f5d332","button":"_8ba1ccdc","spinner":"_dbef01d7"};